<template>
    <div class="background" :style="backImg" :class="fullscreen">
        <!-- <div>
        </div> -->
        <el-row class="topInfo">
            <el-col type="flex" :span="3"><img class="Logo" src="../../../assets/icon/LOGO.png" alt=""/></el-col>
            <button id="wrapp" style="border: none; background-color: transparent; color: transparent">播放</button>
            <el-col type="flex" :span="3"><span class="topTit">可视化声光预警 </span></el-col>
            <el-col :span="12" type="flex" style="display:flex">
                <div class="pageTurning">
                    <img class="mouse" src="../../../assets/icon/left.png" alt="" @click="previousPage" />
                    <span style="color: #fff; font-size: 1.3vw; margin: 0.3vw 0.7vw 0.3vw 1vw"> {{ searchParams.page }} / {{ pages }} </span>
                    <img class="mouse" src="../../../assets/icon/right.png" alt="" @click="nextPage" />
                </div>
                <div style="display:flex;flex-wrap:wrap;width:75%;padding-left:5%;align-items: center;">
                    <div class="reminder" style="width:65%">
                        <div class="blockBox">
                            未接单：小于五分钟
                            <div class="block moduleBg_Gray"></div>
                            大于五分钟
                            <div class="block moduleBg_yellow"></div>
                        </div>
                        <div class="blockBox">
                            维修中：
                            <div>
                                <div>
                                    小于三十分钟
                                    <div class="block" style="background-color:#2788d1"></div>
                                </div>
                                <div style="margin-left:15px">
                                    大于三十分钟
                                    <div class="block moduleBg_Red"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="reminder" style="width:35%;justify-content: center;">
                        <div class="blockBox">
                            验收：
                            <div class="block moduleBg_Greed"></div>
                        </div>
                    </div>
                </div>
            </el-col>
            <el-col type="flex" :span="6">
                <div class="time">
                    <img class="timeimg" src="../../../assets/icon/时间.png" alt="" />
                    <span style="font-size: 1.2vw; margin-left: 1vw">{{ showDate }}</span>

                    <div @click="fullscreens()" v-show="full === true">
                        <img class="mouse" style="width: 1.5vw; height: 1.5vw; margin-left: 2vw" src="../../../assets/icon/全屏.png" alt="" />
                    </div>
                    <div @click="fullscreens2()" v-show="full === false">
                        <img class="mouse" style="width: 1.8vw; height: 1.8vw; margin-left: 2vw" src="../../../assets/icon/缩小.png" alt="" />
                    </div>
                </div>
            </el-col>
        </el-row>
        <el-row class="deptInfo" style="display: flex; margin-left: 1vw" v-if="deptShow">
            <div type="flex">
                <span style="color: white">所属工厂：</span>
                <el-select v-model="fcIdSelected" placeholder="请选择" :clearable="isclear" :disabled="ischeck" filterable @change="fcChange">
                    <el-option v-for="factory in factoryList" :key="factory.value" :label="factory.label" :value="factory.value"></el-option>
                </el-select>
            </div>
            <div type="flex">
                <span style="color: white">所属车间：</span>
                <el-select v-model="shopSelected" placeholder="请选择" multiple collapse-tags clearable filterable @change="shopChange">
                    <el-option v-for="shop in shopList" :key="shop.value" :label="shop.label" :value="shop.value"></el-option>
                </el-select>
            </div>
            <div type="flex" v-if="sectionLineShow">
                <span style="color: white">所属工段：</span>
                <el-select v-model="sectionSelected" placeholder="请选择" clearable filterable @change="sectionChange">
                    <el-option v-for="section in sectionList" :key="section.value" :label="section.label" :value="section.value"></el-option>
                </el-select>
            </div>
            <div type="flex" v-if="sectionLineShow">
                <span style="color: white">所属产线：</span>
                <el-select v-model="lineSelected" placeholder="请选择" clearable filterable @change="lineChange">
                    <el-option v-for="line in lineList" :key="line.value" :label="line.label" :value="line.value"></el-option>
                </el-select>
            </div>
        </el-row>
        <el-row class="deptInfo" style="display: flex; margin-left: 1vw" v-if="deptShow">
            <div type="flex">
                <span style="color: white">安灯状态：</span>
                <el-select v-model="andonStatus" placeholder="请选择" multiple collapse-tags clearable @change="anStatuChange">
                    <el-option label="待接单" value="create"></el-option>
                    <el-option label="待完成" value="wait_complete"></el-option>
                    <el-option label="待验收" value="wait_accept"></el-option>
                </el-select>
            </div>
            <div type="flex">
                <span style="color: white">安灯类型：</span>
                <el-select v-model="aTypeSelected" placeholder="请选择" multiple collapse-tags clearable filterable @change="aTChange">
                    <el-option v-for="atype in aTList" :key="atype.id" :label="atype.label" :value="JSON.stringify(atype.value)">
                        <span style="float: left">{{ atype.label }}</span>
                    </el-option>
                </el-select>
            </div>
            <div type="flex" v-if="isSkip">
                <el-button @click="getFacility">返回</el-button>
            </div>
            <div type="flex" style="align-items:center;display:flex;margin-left:15px">
                <el-switch v-model="policeSwitch" active-text="重复报警" inactive-text="单次报警" @change="policeChange"> </el-switch>
            </div>
        </el-row>
        <div style="display: flex; flex-wrap: wrap">
            <div v-for="(item, index) in tableData" :key="index" class="moduleInfo" :class="bgColorManage(item)" style="width: 48%; margin-left: 1vw; margin-top: 1vh">
                <div style="display: flex; align-items: center" @click="acoUSpe(item)">
                    <img class="repairbill" src="../../../assets/icon/维修单.png" alt="" />
                    <span class="textSty" style="font-size: 1.6vw">Andon号：{{ item.andonCode }}</span>
                    <img style="width: 3vw; height: 2vh; margin-left: 1vw" src="../../../assets/icon/装饰.png" alt="" />
                </div>
                <hr />
                <div style="display: flex; width: 100%">
                    <div style="margin: 0.5vw 0.5vw 0.5vw 1vw; width: 35%">
                        <div style="height: 50%">
                            <p class="textSty2">设备信息：</p>
                            <div :class="textbgColorManage(item)">
                                <div style="text-align: center" class="equiInfotext" :class="[deptShow == false ? 'fullfontsize3' : '']">
                                    <p style="color: #fff; margin-top: -4px">
                                        {{ item.devName }}
                                    </p>
                                </div>
                            </div>
                            <!-- <div class="notice-container equiInfotext" :class="[item.andonStatus.code == 'create' ? 'Smallmodulebg_red' : ' Smallmodulebg_blue']">
                                    <i class="horn fa fa-bullhorn"></i>
                                    <div class="header-notice-marquee" id="notice-marquee">
                                        <p
                                            class="header-marquee-item1 info"
                                            :style="{
                                                'animation-duration': (item.devName ? item.devName.length : 0) + 's'
                                            }"
                                        >
                                            {{ item.devName }}
                                        </p>
                                    </div>
                                </div> -->
                        </div>
                        <div style="height: 50%; margin-top: 1vh">
                            <!-- {{ item.atName }} -->
                            <p class="textSty2">报警类型：</p>
                            <div
                                style="margin-top: 8px"
                                class="alarmtype"
                                :class="[
                                    item.atName == '安全'
                                        ? 'atNameBgColor1'
                                        : item.atName == '质量'
                                        ? 'atNameBgColor2'
                                        : item.atName == '生产'
                                        ? 'atNameBgColor3'
                                        : item.atName == '物流'
                                        ? 'atNameBgColor4'
                                        : item.atName == '工艺'
                                        ? 'atNameBgColor5'
                                        : item.atName == '设备'
                                        ? 'atNameBgColor6'
                                        : item.atName == '人员'
                                        ? 'atNameBgColor7'
                                        : ''
                                ]"
                            >
                                <span :class="[deptShow == false ? 'fullfontsize2' : '']">{{ item.atName }}</span>
                            </div>
                        </div>
                    </div>
                    <div style="margin: 0.5vw 0.5vw 0.5vw 1vw; width: 60%">
                        <div style="width: 100%">
                            <p class="textSty2">发生区域：</p>
                            <div class="textSty2 textbor" style="margin-top: 6px; height: 5vh" :class="textbgColorManage(item)">
                                <p :class="[deptShow == false ? 'fullfontsize1' : '']">产线{{ item.lineName }}工段</p>
                            </div>
                        </div>
                        <div style="width: 100%">
                            <p class="textSty2">问题描述：</p>
                            <div class="textSty2 textbor" style="margin-top: 6px; height: 5vh" :class="textbgColorManage(item)">
                                <p :class="[deptShow == false ? 'fullfontsize1' : '']">{{ item.andonProbDesc }}</p>
                            </div>
                        </div>
                        <div style="width: 100%">
                            <p class="textSty2">报警时间：</p>
                            <div class="textSty2 textbor" style="margin-top: 6px; height: 5vh" :class="textbgColorManage(item)">
                                <p :class="[deptShow == false ? 'fullfontsize1' : '']">{{ item.createTime }}</p>
                            </div>
                        </div>
                        <div style="width: 100%" v-if="item.andonStatus.code == 'wait_complete'">
                            <p class="textSty2">维修用时：</p>
                            <div class="textSty2 textbor fontsty" style="margin-top: 6px; height: 5vh; color: #ffe600" :class="textbgColorManage(item)">
                                <p :class="[deptShow == false ? 'fullfontsize1' : '']">{{ item.myHours }} : {{ item.myMinutes }} : {{ item.mySeconds }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
//创建一个函数来增加月日时小于10在前面加0
import moment from 'moment'

var padaDate = function(value) {
    return value < 10 ? '0' + value : value
}
const synth = window.speechSynthesis
const msg = new SpeechSynthesisUtterance()
export default {
    data() {
        return {
            date: '', //实时时间
            showDate: '', //显示时间
            backImg: {
                backgroundImage: 'url(' + require('../../../assets/icon/background.png') + ')',
                backgroundRepeat: 'no-repeat'
            },
            fullscreen: '',
            full: true,
            searchParams: {
                param: {},
                pageSize: 4,
                page: 1,
                pageCount: 0
            },
            navigateFirstPage: 0,
            navigateLastPage: 0,
            pages: 0,
            first: 0,
            firstFlag: true,
            tableData: [],
            factoryTree: [],
            fcIdSelected: '',
            sectionSelected: '',
            shopSelected: '',
            lineSelected: '',
            andonStatus: '',
            andonTypelist: [],
            aTypeSelected: '',
            aCSelected: '',
            andonTypes: '',
            userInfo: {},
            role: {},
            ischeck: true,
            isclear: false,
            isChange: true,
            deptShow: true,
            sectionLineShow: true,
            intervalId: null,
            nextPageTime: null,
            textSpeck: '',
            currentTime: 0,
            timeObj: null, // 时间对象,下方会用到
            myHours: '00', // 我定义来接收计算出来的 小时 的
            myMinutes: '00', // 我定义来接收计算出来的 分钟 的
            mySeconds: '00', // 我定义来接收计算出来的 秒钟 的
            strLists: '',
            isSkip: false,
            andonStateArray: {},
            tiMingTime: 10000,
            creadOriderList: '',

            speechList: [],
            activeIndex: -1,
            windowMsg: null,
            windowSpeech: null,
            playFlag: true,
            circleFlag: false,
            policeSwitch: false
        }
    },
    computed: {
        factoryList: function() {
            var arr = []
            var userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
            if (this.factoryTree != undefined && this.factoryTree.length > 0) {
                if (this.ischeck) {
                    for (var i = 0; i < this.factoryTree.length; i++) {
                        for (let j = 0; j < userInfo.roles.length; j++) {
                            if (this.factoryTree[i].deptID == userInfo.roles[j].factoryId) {
                                arr.push({
                                    label: this.factoryTree[i].deptName,
                                    id: this.factoryTree[i].deptID,
                                    value: JSON.stringify(this.factoryTree[i]),
                                    deptLevel: this.factoryTree[i].deptLevel,
                                    parent: 0
                                })
                            }
                        }
                    }
                } else {
                    for (var i = 0; i < this.factoryTree.length; i++) {
                        arr.push({
                            label: this.factoryTree[i].deptName,
                            id: this.factoryTree[i].deptID,
                            value: JSON.stringify(this.factoryTree[i]),
                            deptLevel: this.factoryTree[i].deptLevel,
                            parent: 0
                        })
                    }
                }
            }
            return arr
        },
        shopList: function() {
            var arr = []
            if (this.fcIdSelected != undefined && this.fcIdSelected.length > 0) {
                var factory = JSON.parse(this.fcIdSelected)
                var shops = factory.child
                for (var i = 0; i < shops.length; i++) {
                    if (shops[i].hasOwnProperty('deptCode')) {
                        arr.push({
                            label: shops[i].deptName,
                            id: shops[i].deptID,
                            value: JSON.stringify(shops[i]),
                            deptLevel: shops[i].deptLevel,
                            parent: 0
                        })
                    }
                }
            }
            return arr
        },
        sectionList: function() {
            var arr = []
            if (this.shopSelected != undefined && this.shopSelected.length > 0 && this.shopSelected.length <= 1) {
                var shop = JSON.parse(this.shopSelected)
                var vsms = shop.child
                for (var i = 0; i < vsms.length; i++) {
                    if (vsms[i].hasOwnProperty('deptCode')) {
                        arr.push({
                            label: vsms[i].deptName,
                            id: vsms[i].deptID,
                            value: JSON.stringify(vsms[i]),
                            deptLevel: vsms[i].deptLevel,
                            parent: 0
                        })
                    }
                }
            }
            return arr
        },
        lineList: function() {
            var arr = []
            if (this.sectionSelected != undefined && this.sectionSelected.length > 0) {
                var vsm = JSON.parse(this.sectionSelected)
                var lines = vsm.child
                for (var i = 0; i < lines.length; i++) {
                    if (lines[i].hasOwnProperty('deptCode')) {
                        arr.push({
                            label: lines[i].deptName,
                            id: lines[i].deptID,
                            value: JSON.stringify(lines[i]),
                            deptLevel: lines[i].deptLevel,
                            parent: 0
                        })
                    }
                }
            }
            return arr
        },
        aTList: function() {
            var arr = []
            if (this.andonTypelist != undefined && this.andonTypelist.length > 0) {
                for (var i = 0; i < this.andonTypelist.length; i++) {
                    arr.push({
                        label: this.andonTypelist[i].typeName,
                        id: this.andonTypelist[i].id,
                        value: this.andonTypelist[i],
                        parent: 0
                    })
                }
            }
            return arr
        },
        aCList: function() {
            var arr = []
            if (this.aTypeSelected != undefined && this.aTypeSelected.length > 0) {
                var aContent = JSON.parse(this.aTypeSelected)
                var content = aContent.contentList
                if (content != undefined) {
                    for (var i = 0; i < content.length; i++) {
                        arr.push({
                            label: content[i].content,
                            id: content[i].id,
                            value: JSON.stringify(content[i]),
                            parent: 0
                        })
                    }
                }
            }
            return arr
        }
    },
    destroyed() {
        // 在页面销毁后，清除计时器
        this.clear()
        this.playFlag = false
        if (this.windowSpeech) {
            this.windowSpeech.cancel()
        }
    },
    created() {
        this.dataRefreh()
        this.timingfanye() //定时翻页
    },
    mounted() {
        if (this.windowSpeech) {
            this.playFlag = false
            this.windowSpeech.cancel()
        }
        var _this = this //声明一个变量指向vue实例this,保证作用域一致
        this.timer = setInterval(function() {
            _this.date = new Date() //修改数据date
        }, 1000)
        this.init()
    },
    filters: {
        //设置一个函数来进行过滤
        formaDate: function(value) {
            //创建一个时间日期对象
            var date = this.date

            // // date = new Date
            // const request = new XMLHttpRequest()
            // request.onreadystatechange = () =>{
            //     const servetTime = new Date(request.getResponseHeader('Date'))


            //     console.log(servetTime,5555555);
            //     if(servetTime){
            //         date = new Date(servetTime)

            //         // console.log(new Date(servetTime),68686868);
            //     }
            // }
            // request.open('GET','/',true)
            // request.send()

            // console.log(date,9999999);

            var year = date.getFullYear() //存储年
            var month = padaDate(date.getMonth() + 1) //存储月份
            var day = padaDate(date.getDate()) //存储日期
            var hours = padaDate(date.getHours()) //存储时
            var minutes = padaDate(date.getMinutes()) //存储分
            var seconds = padaDate(date.getSeconds()) //存储秒
            //返回格式化后的日期
            return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds + ''
        }
    },
    methods: {
        policeChange() {
            if (!this.playFlag) {
                this.getCreateOrder()
            }
        },
        play(data) {
            this.windowMsg = new window.SpeechSynthesisUtterance()
            this.windowSpeech = window.speechSynthesis
            if (!this.playFlag) {
                console.log('消音了')
                this.windowSpeech.cancel()
                return
            }
            if (!this.windowMsg || !this.windowSpeech) {
                this.windowMsg = new window.SpeechSynthesisUtterance()
                this.windowSpeech = window.speechSynthesis
            }
            this.windowMsg.text = data.text
            this.windowMsg.volume = 1
            this.windowMsg.voiceURI = 'Google 普通话（中国大陆）'

            //   console.log(this.windowMsg, 'this.windowMsg')
            //   console.log(this.windowSpeech, 'this.windowMsg')
            this.windowMsg.onstart = () => {
                // console.log('开始合成')
                this.activeIndex = data.index
                this.speechList[data.index].status = 1
            }
            this.windowMsg.onerror = e => {
                console.log('出问题了', e)
                this.speechList[data.index].status = 0
            }
            this.windowMsg.onend = () => {
                if (this.circleFlag) {
                    //   console.log('播放完成一条', this.activeIndex)
                    this.activeIndex++
                    if (this.activeIndex == this.speechList.length) {
                        this.activeIndex = 0
                    }
                    if (this.activeIndex + 1 == this.speechList.length) {
                        this.playFlag = false
                        this.windowSpeech.cancel()
                        if (this.policeSwitch) {
                            this.allPlay()
                        }
                    } else {
                        this.play(this.speechList[this.activeIndex])
                    }
                } else {
                    this.activeIndex = -1
                }
                if (this.speechList.length > 0) {
                    this.speechList[data.index].status = 0
                }
            }
            this.windowMsg.onresume = () => {
                this.speechList[data.index].status = 1
            }
            this.windowMsg.onpause = e => {
                // console.log('暂停', e)
                this.speechList[data.index].status = 2
            }
            this.windowSpeech.speak(this.windowMsg)
        },
        allPlay() {
            this.playFlag = true
            this.circleFlag = true
            this.activeIndex = 0
            this.play(this.speechList[this.activeIndex])
        },
        // 语音播报的函数
        handleSpeak(text) {
            msg.text = text // 文字内容: 小朋友，你是否有很多问号
            msg.lang = 'zh-CN' // 使用的语言:中文
            msg.volume = 1 // 声音音量：1
            msg.rate = 1 // 语速：1
            msg.pitch = 1 // 音高：1
            synth.speak(msg) // 播放
        },
        // 语音停止
        handleStop(e) {
            msg.text = e
            msg.lang = 'zh-CN'
            synth.cancel(msg)
        },
        init() {
            // this.userInfo = sessionStorage.getItem("userInfo")
            this.userInfo = this.$store.state.userInfo
            var role = this.userInfo.roles
            for (var i = 0; i < role.length; i++) {
                //所有工厂数据
                if (role[i].factoryId == 0) {
                    this.ischeck = false
                    this.role = role[i]
                    this.isclear = true
                    break
                } else {
                    if (this.userInfo.factoryId == role[i].factoryId) {
                        this.role = role[i]
                    }
                }
            }
            // document.getElementById('wrapp').click()
            this.getData()
        },
        // 定时刷新数据函数
        dataRefreh() {
            // 计时器正在进行中，退出函数
            if (this.intervalId != null) {
                return
            }
            // 计时器为空，操作
            this.intervalId = setInterval(() => {
                // console.log('刷新' + new Date())
                this.getSgkshPage() //加载数据函数
            }, 15000)
        },
        // 停止定时器
        clear() {
            clearInterval(this.intervalId) //清除计时器
            clearInterval(this.nextPageTime) //清除计时器
            this.intervalId = null //设置为null
            this.nextPageTime = null
        },
        fullscreens() {
            if (this.fullscreen == '') {
                ;(this.fullscreen = 'fullscreen'), (this.full = false)
                this.deptShow = false
                let docElm = document.documentElement
                if (docElm.requestFullscreen) {
                    docElm.requestFullscreen()
                } else if (docElm.msRequestFullscreen) {
                    docElm.msRequestFullscreen()
                } else if (docElm.mozRequestFullScreen) {
                    docElm.mozRequestFullScreen()
                } else if (docElm.webkitRequestFullScreen) {
                    docElm.webkitRequestFullScreen()
                }
            }
        },
        fullscreens2() {
            if (this.fullscreen != '') {
                this.fullscreen = '' //动态样式改变
                this.full = true //全屏图标切换
                this.deptShow = true //选择显示
                if (document.exitFullscreen) {
                    document.exitFullscreen()
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen()
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen()
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen()
                }
            }
        },
        beforeDestroy() {
            if (this.timer) {
                clearInterval(this.timer) //在vue实例销毁钱，清除我们的定时器
            }
        },
        getColorStyle(item) {
            if (item.andonStatus.code == 'create') {
                return {
                    'background-color': '#EF3636'
                }
            }
        },
        bgColorManage(item) {
            if (!item.andonStatus) return
            if (!item.andonStatus.code) return
            let dateTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
            let stime = Date.parse(new Date(dateTime)) //获得当前时间的毫秒数
            let etime = Date.parse(new Date(item.createTime)) //获得结束时间的毫秒数
            let usedTime = stime - etime
            let timeReault = usedTime / (60 * 1000)
            //[item.andonStatus.code == 'create' ? 'moduleBg_Red' : item.andonStatus.code == 'wait_complete' ? 'moduleBg_yellow' : 'moduleBg_Blue']
            if (item.andonStatus.code == 'create') {
                if (timeReault < 5) {
                    return 'moduleBg_Gray'
                } else {
                    return 'moduleBg_yellow'
                }
            } else if (item.andonStatus.code == 'wait_complete') {
                if (timeReault < 30) {
                    return 'moduleBg_Blue'
                } else {
                    return 'moduleBg_Red'
                }
            } else if (item.andonStatus.code == 'wait_accept') {
                return 'moduleBg_Greed'
            }
        },
        textbgColorManage(item) {
            if (!item.andonStatus) return
            if (!item.andonStatus.code) return
            let dateTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
            let stime = Date.parse(new Date(dateTime)) //获得当前时间的毫秒数
            let etime = Date.parse(new Date(item.createTime)) //获得结束时间的毫秒数
            let usedTime = stime - etime
            let timeReault = usedTime / (60 * 1000)
            //[item.andonStatus.code == 'create' ? 'moduleBg_Red' : item.andonStatus.code == 'wait_complete' ? 'moduleBg_yellow' : 'moduleBg_Blue']
            if (item.andonStatus.code == 'create') {
                if (timeReault < 5) {
                    return 'Smallmodulebg_Gray'
                } else {
                    return 'Smallmodulebg_yellow'
                }
            } else if (item.andonStatus.code == 'wait_complete') {
                if (timeReault < 30) {
                    return 'Smallmodulebg_Blue'
                } else {
                    return 'Smallmodulebg_red'
                }
            } else if (item.andonStatus.code == 'wait_accept') {
                return 'Smallmodulebg_Greed'
            }
        },
        fcChange: function() {
            this.isChange = false
            this.shopSelected = ''
            this.sectionSelected = ''
            this.lineSelected = ''
            this.first = 0
            // this.getSgkshList()
            this.getSgkshPage()
            this.playFlag = false
            if (this.windowSpeech) {
                this.windowSpeech.cancel()
            }
        },
        shopChange: function() {
            if (this.shopSelected.length > 1) {
                this.sectionLineShow = false
            } else {
                this.sectionLineShow = true
            }
            this.sectionSelected = ''
            this.lineSelected = ''
            this.first = 0
            // this.getSgkshList()
            this.getSgkshPage()
            this.playFlag = false
            if (this.windowSpeech) {
                this.windowSpeech.cancel()
            }
        },
        sectionChange: function() {
            this.lineSelected = ''
            this.first = 0
            // this.getSgkshList()
            this.getSgkshPage()
            this.playFlag = false
            if (this.windowSpeech) {
                this.windowSpeech.cancel()
            }
        },
        lineChange: function() {
            this.first = 0
            // this.getSgkshList()
            this.getSgkshPage()
            this.playFlag = false
            if (this.windowSpeech) {
                this.windowSpeech.cancel()
            }
        },
        anStatuChange() {
            this.first = 0
            // this.getSgkshList()
            this.getSgkshPage()
            this.playFlag = false
            if (this.windowSpeech) {
                this.windowSpeech.cancel()
            }
        },
        aTChange() {
            this.first = 0
            // this.getSgkshList()
            this.getSgkshPage()
            this.playFlag = false
            if (this.windowSpeech) {
                this.windowSpeech.cancel()
            }
        },
        acoUSpe(row) {
            if (row != null) {
                var array = JSON.parse(JSON.stringify(row))
                if (this.fcIdSelected != undefined && this.fcIdSelected != '') {
                    array['fcCode'] = JSON.parse(this.fcIdSelected).deptCode
                }
                if (this.shopSelected.length > 1) {
                    array['shopCode'] = row.shopCode
                } else {
                    if (this.shopSelected != undefined && this.shopSelected != '') {
                        array['shopCode'] = JSON.parse(this.shopSelected).deptCode
                    }
                }
                if (this.sectionSelected != undefined && this.sectionSelected != '') {
                    array['sectionCode'] = JSON.parse(this.sectionSelected).deptCode
                }
                if (this.lineSelected != undefined && this.lineSelected != '') {
                    array['lineCode'] = JSON.parse(this.lineSelected).deptCode
                }
                this.$router.push({
                    name: 'andonOrderList',
                    params: {
                        acouStoSpe: array
                    }
                })
            }
        },
        //定时翻页
        timingfanye() {
            if (this.nextPageTime != null) {
                return
            }
            this.nextPageTime = setInterval(() => {
                this.nextPage()
            }, this.tiMingTime)
        },
        previousPage() {
            if (this.searchParams.page == 1) {
                return
            } else {
                this.searchParams.page = this.searchParams.page - 1
            }
            this.getSgkshPage()
        },
        nextPage() {
            if (this.searchParams.page >= this.pages) {
                this.searchParams.page = 1
            } else {
                this.searchParams.page = this.searchParams.page + 1
            }
        },
        getFacility() {
            this.$router.push({
                name: 'facilitySpectaculars',
                params: {
                    full: 'true'
                }
            })
        },
        getSgkshList() {
            let queryParams = {}
            if (this.fcIdSelected != undefined && this.fcIdSelected != '') {
                queryParams['fcCode'] = JSON.parse(this.fcIdSelected).deptCode
            }
            var str = ''
            if (this.shopSelected.length > 1) {
                for (let i = 0; i < this.shopSelected.length; i++) {
                    str += JSON.parse(this.shopSelected[i]).deptCode + ','
                }
                str = str.substring(0, str.length - 1)
                queryParams['shopCode'] = str
            } else {
                if (this.shopSelected != undefined && this.shopSelected != '') {
                    queryParams['shopCode'] = JSON.parse(this.shopSelected).deptCode
                }
            }
            if (this.sectionSelected != undefined && this.sectionSelected != '') {
                queryParams['sectionCode'] = JSON.parse(this.sectionSelected).deptCode
            }
            if (this.lineSelected != undefined && this.lineSelected != '') {
                queryParams['lineCode'] = JSON.parse(this.lineSelected).deptCode
            }
            let andonStatus = ''
            if (this.andonStatus.length > 1) {
                for (let i = 0; i < this.andonStatus.length; i++) {
                    andonStatus += this.andonStatus[i] + ','
                }
                andonStatus = andonStatus.substring(0, andonStatus.length - 1)
                queryParams['andonStatus'] = andonStatus
            } else {
                if (this.andonStatus != undefined && this.andonStatus != '') {
                    queryParams['andonStatus'] = this.andonStatus[0]
                }
            }
            let andonType = ''
            if (this.aTypeSelected.length > 1) {
                for (let i = 0; i < this.aTypeSelected.length; i++) {
                    andonType += JSON.parse(this.aTypeSelected[i]).id + ','
                }
                andonType = andonType.substring(0, andonType.length - 1)
                queryParams['andonTypes'] = andonType
            } else {
                if (this.aTypeSelected != undefined && this.aTypeSelected != '') {
                    queryParams['andonTypes'] = JSON.parse(this.aTypeSelected).id
                }
            }
            let options = {
                method: 'GET',
                url: this.$api.sgkshList,
                params: queryParams,
				withToken:false
            }
            this.$http.request(options).then(response => {
                if (response.status == 100) {
                    if (response.data != undefined && response.data != '') {
                        this.strLists = response.data
                    }
                }
            })
        },
        getSgkshPage() {
            let queryParams = {
                pageSize: this.searchParams.pageSize,
                pageNum: this.searchParams.page,
				withToken:false
            }
            var self = this
            if (self.fcIdSelected != undefined && self.fcIdSelected != '') {
                queryParams['fcCode'] = JSON.parse(self.fcIdSelected).deptCode
            }
            let str = ''
            if (self.shopSelected.length > 1) {
                for (let i = 0; i < self.shopSelected.length; i++) {
                    str += JSON.parse(self.shopSelected[i]).deptCode + ','
                }
                str = str.substring(0, str.length - 1)
                queryParams['shopCode'] = str
            } else {
                if (self.shopSelected != undefined && self.shopSelected != '') {
                    queryParams['shopCode'] = JSON.parse(self.shopSelected).deptCode
                }
            }
            if (self.sectionSelected != undefined && self.sectionSelected != '') {
                queryParams['sectionCode'] = JSON.parse(self.sectionSelected).deptCode
            }
            if (self.lineSelected != undefined && self.lineSelected != '') {
                queryParams['lineCode'] = JSON.parse(self.lineSelected).deptCode
            }
            let andonStatus = ''
            if (self.andonStatus.length > 1) {
                for (let i = 0; i < self.andonStatus.length; i++) {
                    andonStatus += self.andonStatus[i] + ','
                }
                andonStatus = andonStatus.substring(0, andonStatus.length - 1)
                queryParams['andonStatus'] = andonStatus
            } else {
                if (self.andonStatus != undefined && self.andonStatus != '') {
                    queryParams['andonStatus'] = self.andonStatus[0]
                }
            }
            let andonType = ''
            if (self.aTypeSelected.length > 1) {
                for (let i = 0; i < self.aTypeSelected.length; i++) {
                    andonType += JSON.parse(self.aTypeSelected[i]).id + ','
                }
                andonType = andonType.substring(0, andonType.length - 1)
                queryParams['andonTypes'] = andonType
            } else {
                if (self.aTypeSelected != undefined && self.aTypeSelected != '') {
                    queryParams['andonTypes'] = JSON.parse(self.aTypeSelected).id
                }
            }
            let options = {
                method: 'GET',
                url: this.$api.sgkshPage,
                params: queryParams,
				withToken:false
            }
            this.$http.request(options).then(response => {
                this.showDate = response.date

                if (response.status == 100) {

                    if (response.data.andonPage.list != undefined && response.data.andonPage.list != '') {
                        self.tableData = response.data.andonPage.list
                        this.strLists = response.data.andonList
                        const date = new Date(response.date).getTime()
                        var arr = []
                        for (let a0 = 0; a0 < self.tableData.length; a0++) {
                            var array = {
                                andonCode: '',
                                atName: '',
                                devName: '',
                                lineName: '',
                                andonProbDesc: '',
                                createTime: '',
                                andonStatus: '',
                                andonRespTime: '',
                                myHours: '',
                                myMinutes: '',
                                mySeconds: '',
                                shopCode: '',
                                sectionCode: '',
                                lineCode: ''
                            }
                            array.andonCode = self.tableData[a0].andonCode
                            array.atName = self.tableData[a0].atName
                            array.devName = self.tableData[a0].devName
                            array.lineName = self.tableData[a0].lineName
                            array.andonProbDesc = self.tableData[a0].andonProbDesc
                            array.createTime = self.tableData[a0].createTime
                            array.andonStatus = self.tableData[a0].andonStatus
                            array.shopCode = self.tableData[a0].shopCode
                            array.sectionCode = self.tableData[a0].sectionCode
                            array.lineCode = self.tableData[a0].lineCode
                            if (this.tableData[a0].andonStatus.code == 'wait_complete') {
                                // var currentDate = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
                                // var date = new Date(currentDate).getTime()
                                var andonRespTime = new Date(this.tableData[a0].andonRespTime).getTime()
                                var currentTime = parseInt(date - andonRespTime) / 1000
                                // console.log('currentTime', Math.floor(currentTime / 60 / 60))
                                // 开始执行倒计时
                                var timeObj = {
                                    // 时间对象
                                    seconds: Math.floor(currentTime % 60),
                                    minutes: Math.floor(currentTime / 60) % 60,
                                    // hours: Math.floor(currentTime / 60 / 60) % 24
                                    hours: Math.floor(currentTime / 60 / 60)
                                    // hours: Math.floor((date - andonRespTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
                                }
                                // 计算出时分秒
                                array.myHours = timeObj.hours < 10 ? '0' + timeObj.hours : timeObj.hours
                                array.myMinutes = timeObj.minutes < 10 ? '0' + timeObj.minutes : timeObj.minutes
                                array.mySeconds = timeObj.seconds < 10 ? '0' + timeObj.seconds : timeObj.seconds
                            }
                            arr.push(array)
                        }
                        self.tableData = []
                        self.tableData = arr
                        self.searchParams.pageCount = response.data.andonPage.total
                        self.navigateFirstPage = response.data.andonPage.navigateFirstPage
                        self.navigateLastPage = response.data.andonPage.navigateLastPage
                        self.pages = response.data.andonPage.pages
                        self.buildOrderUpdate()
                    } else {
                        self.tableData = []
                    }
                } else {
                    self.tableData = []
                }
            })
        },
        //处理订单是否有更新
        buildOrderUpdate() {
            var self = this
            var isUpdate = false
            var andonCode = ''
            //第一次进来缓存存储数据
            if (self.first === 0 && self.firstFlag) {
                sessionStorage.setItem('acoustoSpe', JSON.stringify(self.strLists))
                self.first++
            }
            //刷新所有数据(最新数据包含新的单子)
            if (self.first !== 0) {
                // self.getSgkshList()
                sessionStorage.setItem('acoustoSpeTo', JSON.stringify(self.strLists))
            }
            var bb = JSON.parse(sessionStorage.getItem('acoustoSpeTo'))
            var aa = JSON.parse(sessionStorage.getItem('acoustoSpe'))
            //检测数据是否一致,否则跳到第一页
            if (aa != bb) {
                //没新单子,判断数据是否存在不相同的,相同为self.first = 0,不相同为self.first != 0
                let aco = aa.split(',')
                let acoTo = bb.split(',')
                //取不同的元素（ES6的方法）
                andonCode = acoTo.filter(item => !aco.some(ele => ele === item))
                self.creadOriderList = andonCode
                if (andonCode.length != 0) {
                    self.first = 0
                    isUpdate = true
                    self.searchParams.page = 1
                    self.tiMingTime = 10000
                } else {
                    self.playFlag = false
                    self.speechList = []
                    if (this.windowSpeech) {
                        this.windowSpeech.cancel()
                    }
                }
            }
            if (isUpdate) {
                self.playFlag = false
                if (this.windowSpeech) {
                    this.windowSpeech.cancel()
                }
                self.orderManage()
            }
        },
        getCreateOrder() {
            let self = this
            let queryParams = {}
            if (this.fcIdSelected != undefined && this.fcIdSelected != '') {
                queryParams['fcCode'] = JSON.parse(this.fcIdSelected).deptCode
            }
            var str = ''
            if (this.shopSelected.length > 1) {
                for (let i = 0; i < this.shopSelected.length; i++) {
                    str += JSON.parse(this.shopSelected[i]).deptCode + ','
                }
                str = str.substring(0, str.length - 1)
                queryParams['shopCode'] = str
            } else {
                if (this.shopSelected != undefined && this.shopSelected != '') {
                    queryParams['shopCode'] = JSON.parse(this.shopSelected).deptCode
                }
            }
            if (this.sectionSelected != undefined && this.sectionSelected != '') {
                queryParams['sectionCode'] = JSON.parse(this.sectionSelected).deptCode
            }
            if (this.lineSelected != undefined && this.lineSelected != '') {
                queryParams['lineCode'] = JSON.parse(this.lineSelected).deptCode
            }
            queryParams['andonStatus'] = 'create'
            let andonType = ''
            if (this.aTypeSelected.length > 1) {
                for (let i = 0; i < this.aTypeSelected.length; i++) {
                    andonType += JSON.parse(this.aTypeSelected[i]).id + ','
                }
                andonType = andonType.substring(0, andonType.length - 1)
                queryParams['andonTypes'] = andonType
            } else {
                if (this.aTypeSelected != undefined && this.aTypeSelected != '') {
                    queryParams['andonTypes'] = JSON.parse(this.aTypeSelected).id
                }
            }
            let options = {
                method: 'GET',
                url: this.$api.sgkshList,
                params: queryParams,
				withToken:false
            }
            this.$http.request(options).then(response => {
                if (response.status == 100) {
                    if (response.data) {
                        self.creadOriderList = response.data
                        self.orderManage()
                    }
                }
            })
        },
        orderManage() {
            let self = this
            self.speechList = []
            if (self.creadOriderList) {
                let options = {
                    method: 'get',
                    url: this.$api.getAndonOrderDetail,
                    params: {
                        andonCodes: self.creadOriderList[self.creadOriderList.length - 1]
                    }
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        if (response.data) {
                            let andonOrder = response.data
                            andonOrder.forEach((orderItem, OrderIndex) => {
                                var devName = orderItem.devName
                                var shopName = orderItem.shopName
                                var lineName = orderItem.lineName
                                var atName = orderItem.atName
                                if (devName) {
                                    self.textSpeck = '设备' + devName + ',车间' + shopName + ',产线' + lineName + '存在' + atName + '异常，请及时处理'
                                } else {
                                    self.textSpeck = '车间' + shopName + ',产线' + lineName + '存在' + atName + '异常，请及时处理'
                                }
                                self.speechList.push({
                                    text: self.textSpeck,
                                    index: OrderIndex,
                                    status: 0
                                })
                            })
                            self.allPlay()
                        }
                    }
                })
            }
        },

        /*testTimer(){
        this.timeFunction();
        setInterval(() => {
            this.timeFunction();
        }, 1000)
    },
    timeFunction(){
        // 开始执行倒计时
        this.timeObj = { // 时间对象
            seconds: Math.floor(this.currentTime % 60),
            minutes: Math.floor(this.currentTime / 60) % 60,
            hours: Math.floor(this.currentTime / 60 / 60) % 24
        }
        // 计算出时分秒
        this.myHours = this.timeObj.hours<10?'0'+this.timeObj.hours:this.timeObj.hours;
        this.myMinutes = this.timeObj.minutes<10?'0'+this.timeObj.minutes:this.timeObj.minutes;
        this.mySeconds = this.timeObj.seconds<10?'0'+this.timeObj.seconds:this.timeObj.seconds;
        console.log('myHours:' + this.myHours + 'myMinutes:' + this.myMinutes + 'mySeconds:' + this.mySeconds)
        this.currentTime++;
    },*/
        getAndonType() {
            var params = {}
            if (this.fcIdSelected != undefined && this.fcIdSelected != '') {
                params['fcCode'] = JSON.parse(this.fcIdSelected).deptCode
            }
            let options = {
                method: 'GET',
                url: this.$api.getAndonRule,
                params: params,
				withToken:false
            }
            var self = this
            this.$http.request(options).then(response => {
                this.andonTypelist = response.data
                if (self.andonStateArray != undefined && self.andonStateArray != '') {
                    for (let i = 0; i < self.andonTypelist.length; i++) {
                        if (self.andonTypelist[i].typeName == self.andonTypes) {
                            self.aTypeSelected.push(JSON.stringify(self.andonTypelist[i]))
                        }
                    }
                }
            })
        },
        getData() {
            var self = this
            let options = {
                method: 'GET',
                url: this.$api.departTree,
				withToken:false
            }
            this.$http.request(options).then(response => {
                this.factoryTree = response.data
                for (var i = 0; i < self.factoryTree.length; i++) {
                    if (self.ischeck && self.isChange && !self.isSkip) {
                        if (self.factoryTree[i].deptID == self.role.factoryId) {
                            self.fcIdSelected = JSON.stringify(self.factoryTree[i])
                        }
                    } else if (!this.ischeck && this.isChange && !self.isSkip) {
                        self.fcIdSelected = JSON.stringify(self.factoryTree[0])
                    }
                    //新工厂看板
                    if (self.$route.params.andonState != undefined && self.$route.params.andonState != '') {
                        self.andonStatus = []
                        self.isSkip = true
                        self.andonStateArray = self.$route.params.andonState
                        if (self.andonStateArray.hasOwnProperty('andonStatus')) {
                            self.andonStatus.push(self.andonStateArray.andonStatus)
                        }
                        if (self.andonStateArray.hasOwnProperty('andonTypes')) {
                            self.andonTypes = self.andonStateArray.andonTypes
                        }
                        let fcCodeList = []
                        if (self.andonStateArray.hasOwnProperty('fcCode')) {
                            fcCodeList = self.andonStateArray.fcCode.split(',')
                        }
                        if (fcCodeList.length > 1) {
                            self.andonStateArray.fcCode = fcCodeList[0]
                        }
                        if (self.andonStateArray.hasOwnProperty('fcCode')) {
                            if (self.factoryTree[i].deptCode == self.andonStateArray.fcCode) {
                                self.fcIdSelected = JSON.stringify(self.factoryTree[i])
                                if (self.andonStateArray.hasOwnProperty('shopCode')) {
                                    var shops = JSON.parse(self.fcIdSelected).child
                                    for (let j = 0; j < shops.length; j++) {
                                        if (shops[j].hasOwnProperty('deptCode')) {
                                            if (shops[j].deptCode == self.andonStateArray.shopCode) {
                                                self.shopSelected.push(JSON.stringify(shops[j]))
                                                if (self.andonStateArray.hasOwnProperty('sectionCode')) {
                                                    var sections = JSON.parse(self.shopSelected).child
                                                    for (let k = 0; k < sections.length; k++) {
                                                        if (sections[k].hasOwnProperty('deptCode')) {
                                                            if (sections[k].deptCode == self.andonStateArray.sectionCode) {
                                                                self.sectionSelected = JSON.stringify(sections[k])
                                                                if (self.andonStateArray.hasOwnProperty('lineCode')) {
                                                                    var lines = JSON.parse(self.sectionSelected).child
                                                                    for (let l = 0; l < lines.length; l++) {
                                                                        if (lines[l].hasOwnProperty('deptCode')) {
                                                                            if (lines[l].deptCode == self.andonStateArray.lineCode) {
                                                                                self.lineSelected = JSON.stringify(lines[l])
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    } else {
                        self.isSkip = false
                    }
                }
                this.getAndonType()
                // this.getSgkshList()
                this.$nextTick(() => {
                    this.getSgkshPage()
                })
            })
        }
    },
    watch: {
        searchParams: {
            handler(val) {
                this.searchParams.page = val.page
            },
            deep: true,
            immediate: true
        }
    }
}
</script>

<style lang="scss" scoped>
.el-container .el-container .el-main .pageBox > div {
    height: 100%;
}
::v-deep .el-switch__label.is-active {
    color: #54a6fb;
}
::v-deep .el-switch__label {
    color: #fff;
}
.background {
    zoom: 1;
    width: 100%;
    height: 100%;
    text-align: left;
    background-size: cover;
    -o-background-size: cover;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-position: center 0;
    -webkit-background-size: cover;
}

.topInfo {
    height: 8vh;
    display: flex;
    margin-bottom: 14px;
    box-shadow: 0 1px 15px #000;
    border-bottom: 0.4vh #ffbf44 solid;
}

.Logo {
    width: 8vw;
    height: 7.5vh;
    margin: 0.5vh 0 0 1vw;
}

.topTit {
    width: 100%;
    height: 100%;
    display: flex;
    color: #fff;
    font-size: 1.4vw;
    align-items: center;
}

.pageTurning {
    width: 25%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.timeimg {
    width: 1vw;
    height: 2vh;
}

.time {
    width: 100%;
    height: 100%;
    color: #fff;
    display: flex;
    letter-spacing: 1px;
    align-items: center;
}

.equiInfotext {
    width: 100%;
    height: 13vh;
    display: flex;
    margin-top: 6px;
    font-size: 2.5vw;
    overflow: hidden;
    font-weight: bold;
    border: 3px solid #35ebcf;
}

.alarmtype {
    font-weight: bold;
    color: #fff;
    width: 100%;
    justify-content: center;
    font-size: 3.8vw;
    display: flex;
    height: 13vh;
    align-items: center;
}

.el-row {
    &:last-child {
        margin-bottom: 0;
    }
}

.moduleInfo {
    height: 43vh;
    margin-bottom: 0.65vw;
    border: 0.1px #cccccc78 solid;
}
.moduleBg_Red {
    font-size: 1.2vw;
    background-color: #e01010;
}

.moduleBg_yellow {
    font-size: 1.2vw;
    background-color: #efc714;
}
.moduleBg_Blue {
    font-size: 1.3vw;
    background-color: #00589acc;
}
.moduleBg_Gray {
    font-size: 1.2vw;
    background-color: #9e9e9e;
}
.moduleBg_Greed {
    font-size: 1.2vw;
    background-color: #24d424;
}

.Smallmodulebg_red {
    background-color: #741409;
}

.Smallmodulebg_yellow {
    background-color: #b0964c;
}
.Smallmodulebg_blue {
    background-color: #093474;
}

.Smallmodulebg_Gray {
    background-color: #727272;
}
.Smallmodulebg_Greed {
    background-color: #258825;
}

.atNameBgColor1 {
    background-color: #e9b439;
}

.atNameBgColor2 {
    background-color: #23af97;
}

.atNameBgColor3 {
    background-color: #73bb15;
}

.atNameBgColor4 {
    background-color: #2c75c8;
}

.atNameBgColor5 {
    background-color: #c716db;
}

.atNameBgColor6 {
    background-color: #ff8585;
}

.atNameBgColor7 {
    background-color: #e88c3b;
}

.fullfontsize1 {
    font-size: 2vw;
}

.fullfontsize2 {
    font-size: 5.5vw;
}

.fullfontsize3 {
    height: 14vh;
    font-size: 3vw;
}

.repairbill {
    height: 3vh;
    width: 1.1vw;
    margin: 0.5vw 0.7vw 0.5vw 1vw;
}

.textSty {
    color: #35ebcf;
    display: flex;
    align-items: center;
}

hr {
    background-color: #cccccc78;
    height: 1px;
    border: none;
}

.textSty2 {
    color: #fff;
}

.mouse {
    cursor: pointer;
}

.fullscreen {
    top: 0;
    left: 0;
    z-index: 9999;
    position: absolute;
}

// 选择框样式
.el-select ::v-deep .el-input__inner {
    background-color: #0c4686 !important;
    border: 1px #2c2ca28a solid !important;
    color: #fff !important;
}

.textbor {
    width: 100%;
    display: flex;
    padding: 0.1vw;
    font-size: 1.6vw;
    overflow: hidden;
    border: 1.5px #35ebcf solid;
}

//设备信息滚动动画
.notice-container {
    // padding: 0 10px;
    align-items: center;
    // margin: 0 auto;
    display: flex;
    color: #fff;
    flex-direction: row;
    flex: 1;
}

.header-notice-marquee {
    white-space: nowrap;
    overflow: hidden;
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    line-height: 20px;
}

.notice-container .header-marquee-item1 {
    // margin: 0 10px;
    position: absolute;
    left: 0;
    // animation-name: marquee1;
    // animation-timing-function: linear;
    animation: marquee1 linear infinite; //不控制秒 只设置动画名，怎么移动，循环次数
    // animation-direction: alternate;
}

.notice-container .header-marquee-item1 .info {
    padding: 0.3vw 0.3vw 0.3vw 0.5vw;
    white-space: nowrap;
}

.notice-container .header-marquee-item2 {
    margin: 0 10px;
    position: absolute;
    left: 0vw;
    animation: marquee2 15s linear 8; //控制秒数
}

.notice-container .header-notice-marquee:hover {
    animation-play-state: paused;
}

.notice-container .header-notice-marquee .header-marquee-item {
    position: absolute;
    top: 0;
    left: 0;
    white-space: nowrap;
}

@keyframes marquee1 {
    0% {
        left: 100%;
    }
    100% {
        left: -130%;
    }
}

@keyframes marquee2 {
    0% {
        left: 100%;
    }
    100% {
        left: 0%;
    }
}

.fontsty {
    font-family: 'Normal';
}

.deptInfo {
    span {
        margin-left: 0.8vw;
    }
}
.reminder {
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}
.blockBox {
    display: flex;
    color: #fff;
    font-size: 0.9vw;
    font-weight: 800;
    align-items: center;
    white-space: nowrap;
}
.blockBox div {
    display: flex;
    align-items: center;
}
.block {
    width: 0.7vw;
    height: 1.4vh;
    margin: 0 10px;
}
</style>
